import BranchSkeleton from "./BranchSkeleton";
import { Stack } from "@mui/material";

const branchListSkeleton = () => {
  return (
    <Stack spacing={2}>
      <BranchSkeleton />
      <BranchSkeleton />
      <BranchSkeleton />
      <BranchSkeleton />
    </Stack>
  );
};

export default branchListSkeleton;
